<i18n locale="en">
{
  "header": "\"{title}\" Submissions",
  "subheader": "View the submissions people have submitted to your form.",
  "view-form": "View Form",
  "export": "Export Submissions",
  "export-error": "Could not export submissions."
}
</i18n>
<template>
  <OwnScrollContainer>
    <DefaultPageLayout
      :title="header"
      :subtitle="t('subheader')"
      :max-width="1040"
    >
      <template #actions>
        <div class="flex-row gap-3">
          <OwnButton :text="t('view-form')" @click="onViewForm" />
          <OwnButton
            :text="t('export')"
            :processing="exporting"
            variant="primary"
            @click="onExportSubmissions"
          />
        </div>
      </template>
      <FormBuilderSubmissionsTable v-if="currentResource" />
    </DefaultPageLayout>
  </OwnScrollContainer>
</template>
<script>
import { useI18n } from 'vue-i18n'
import { mapGetters } from 'vuex'

import DefaultPageLayout from '@/components/layouts/components/page/DefaultPageLayout.vue'
import { logError } from '@/logger'
import notify from '@/mixins/notify'
import { OlympusClient } from '@/OlympusClient'
import { OwnButton } from '@/ui/OwnButton'
import { OwnScrollContainer } from '@/ui/OwnScrollContainer'
import { download } from '@/utils/download'
import { toRouteLocation } from '@/utils/toRouteLocation'

import { formBuilderRouteManager } from '../../formBuilderModuleRouter'

import FormBuilderSubmissionsTable from './submissions-table/FormBuilderSubmissionsTable.vue'

export default {
  name: 'FormBuilderSubmissionContent',
  components: {
    DefaultPageLayout,
    FormBuilderSubmissionsTable,
    OwnButton,
    OwnScrollContainer,
  },
  mixins: [notify],
  data() {
    return {
      exporting: false,
    }
  },
  setup() {
    const { t } = useI18n()

    return { t }
  },
  computed: {
    ...mapGetters({
      currentResource: 'formBuilder/currentResource',
    }),
    header() {
      const { currentResource } = this

      return currentResource
        ? this.t('header', { title: currentResource.title })
        : undefined
    },
  },
  methods: {
    async onExportSubmissions() {
      const { currentResource } = this

      try {
        this.exporting = true
        const { downloadUrl } =
          await OlympusClient.forms.v1.forms.form.exportSubmissions({
            params: { formId: currentResource.id },
          })

        download(downloadUrl)
        this.$analytics.track('CSV Export', { type: 'Form Submissions' })
      } catch (error) {
        logError(error)
        this.$notify(this.t('export-error'), 'error')
      } finally {
        this.exporting = false
      }
    },
    async onViewForm() {
      const { currentResource } = this

      const editRoute = await formBuilderRouteManager.editResourcePage(
        currentResource.id,
        toRouteLocation(this.$route)
      )

      await this.$router.push(editRoute)
    },
  },
}
</script>
